import { CategoryMapNeimeng } from "../js/CategoryMapNeimeng.js";
import { CategoryMapPaiZu } from "../js/CategoryMapPaiZu";
import { CategoryPetition } from "../js/CategoryPetition";
import store from "../store";

let numberList = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']

function dictConver(dictCode, json) {
  for (let i = 0; i < json.length; i++) {
    if (dictCode === json[i].code) {
      return json[i].name;
    } else {
      if (json[i].children) {
        let result = dictConver(dictCode, json[i].children);
        if (result) {
          return result;
        }
      } else {
        if (json[i].children) {
          let result = dictConver(dictCode, json[i].children);
          if (result) {
            return result;
          }
        }
      }
    }
  }
  return null;
}
export function dictConverFilter(params, params1, dictCode, dict,
  parentCode) { // 字典转换  params params1:对比字段名称 dictCode：对比字段值 dict：字典json parentCode:父级code
  let json = dict ? dict : CategoryPetition
  // console.log(json,'5555');
  for (let i = 0; i < json.length; i++) {
    if (parentCode) {
      if (parentCode == json[i].code) {
        let res = dictConverFilter(params, params1, dictCode, json[i].children);
        return res
      }
    } else if (dictCode == json[i][params]) {
      return json[i][params1];
    } else {
      if (json[i].children) {
        let result = dictConverFilter(params, params1, dictCode, json[i].children);
        if (result) {
          return result;
        }
      } else {
        if (json[i].children) {
          let result = dictConverFilter(params, params1, dictCode, json[i].children);
          if (result) {
            return result;
          }
        }
      }
    }
  }
  return '';
}
export function firstHandle(str) {
  return dictConver(str, CategoryMapNeimeng);
}

export function PzHandle(str) {
  return dictConver(str, CategoryMapPaiZu);
}

export function petitionHandle(str) {
  return dictConver(str, CategoryPetition);
}

export function hasReportName(str) {
  return !str ? "暂无" : str;
}

export function remarks(str) {
  return !str ? "暂无" : str;
}

export function my_days(str) {
  return value + "天";
}

export function inspectionMethod(str) {
  if (str == "1") {
    return "常规巡视（巡察）";
  } else if (str == "2") {
    return "专项巡视（巡察）";
  } else if (str == "3") {
    return "“机动式”巡视（巡察）";
  } else if (str == "4") {
    return "巡视（巡察）“回头看”";
  } else if (str == "5") {
    return "提级巡视（巡察）";
  }
}

export function readArchive(str) {
  if (str == "1") {
    return "整改情况较好";
  } else if (str == "2") {
    return "整改基本到位";
  } else if (str == "3") {
    return "整改迟缓";
  } else if (str == "4") {
    return "整改敷衍";
  }
}

export function problemSource(str) {
  if (str == "type1") {
    return "书记点人点事";
  } else if (str == "type2") {
    return "巡视发现";
  } else if (str == "type3") {
    return "主动发现";
  } else if (str == "type4") {
    return "下级上报";
  } else if (str == "type5") {
    return "长期未整改";
  }
}

export function clueStatus(str) {
  if (str == "unPush") {
    return "未推送";
  } else if (str == "unDisposed") {
    return "未签收";
  } else if (str == "unFeedback") {
    return "未反馈";
  } else if (str == "feedback") {
    return "已反馈";
  }else{
    return "未定义";
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  if (!time) {
    return ''
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

// =========展示文件类型 W/P/S=============
export function suffix(suffix) {
  suffix = suffix.toLowerCase();
  let fileType;
  if (
    suffix == "doc" ||
    suffix == "dot" ||
    suffix == "wps" ||
    suffix == "wpt" ||
    suffix == "docx" ||
    suffix == "dotx" ||
    suffix == "docm" ||
    suffix == "dotm"
  ) {
    fileType = "w";
  } else if (
    suffix == "xls" ||
    suffix == "xlt" ||
    suffix == "et" ||
    suffix == "xlsx" ||
    suffix == "xltx" ||
    suffix == "xlsm" ||
    suffix == "xltm"
  ) {
    fileType = "s";
  } else if (
    suffix == "ppt" ||
    suffix == "pptx" ||
    suffix == "pptm" ||
    suffix == "ppsx" ||
    suffix == "ppsm" ||
    suffix == "pps" ||
    suffix == "potx" ||
    suffix == "potm" ||
    suffix == "dpt" ||
    suffix == "dps"
  ) {
    fileType = "p";
  }
  else if (suffix == "pdf") {
  	fileType = "f";
  }
  else {
    fileType = "";
  }
  return fileType;
}

// 数字转文本
export function num2text(num) {
  if (typeof num != "number") {
    return 'error'
  }
  let numStr = num.toString();

  if (num <= 10) {
    return numberList[num]
  } else if (num > 10 && num < 100) {
    if (num % 10 == 0) {
      return numberList[numStr[0]] + '十'
    } else {
      return (numStr[0] == '1' ? '' : numberList[numStr[0]]) + '十' + numberList[numStr[1]]
    }
  } else {
    return "不考虑此范围";
  }
}

// 标题格式化
export function titleFormat({ inspectedUnitName, numberOfSessions, rounds }, title) {
  let unit = '';
  if (inspectedUnitName.length) {
    let UnitName = inspectedUnitName.split(','),
      le = UnitName.length;
    unit = UnitName[0] + (le > 1 ? ('等' + le + '家单位') : '');
  }
  let str1 = '',
    str2 = '';
  if (numberOfSessions) {
    let num1 = parseFloat(numberOfSessions.substring(1));
    str1 = num1 ? `第${num2text(num1)}届` : ''
  }
  if (rounds) {
    let num2 = parseFloat(rounds.substring(1));
    str2 = num2 ? `第${num2text(num2)}轮` : ''
  }
  let name = store.state.offlineMaterial.areaOrgName
  return str1 + (name ? name : '江西省') + str2 + unit + title;
}

export function getMaplist(codeType) {
  let inspectionMethodlist = [{ code: '', name: '' }];
  CategoryMapPaiZu.forEach(item => {
    if (item.code === codeType) {
      inspectionMethodlist = [];
      item.children.forEach(ele => {
        inspectionMethodlist.push({ code: ele.code, name: ele.name })
      })
    }
  })
  return inspectionMethodlist;
}

export function angleMarkText(row) {
  if (row.isCustomList != 'Y' && !row.questionTypeSecondCode) {
    return '巡视巡察标签和四个落实未填写'
  } else if (row.isCustomList != 'Y') {
    return '巡视巡察标签未填写'
  } else if (!row.questionTypeSecondCode) {
    return '四个落实未填写'
  }
}



// WEBPACK FOOTER //
// ./src/filters/filters.js